import type { OfficeHost } from '../office/bootstrap';
import type { ContextScope } from '../office/context';
import { quickActionsFor } from '../lib/hostQuickActions';

interface Props {
  host: OfficeHost;
  onPick: (prompt: string, scope: ContextScope) => void;
  disabled?: boolean;
}

export function QuickActions({ host, onPick, disabled }: Props) {
  const actions = quickActionsFor(host);
  if (actions.length === 0) return null;
  return (
    <div>
      <div className="mb-1 text-[11px] font-medium uppercase tracking-wide text-ink-500">
        Quick actions
      </div>
      <div className="flex flex-wrap gap-1.5">
        {actions.map((a) => (
          <button
            key={a.id}
            type="button"
            disabled={disabled}
            onClick={() => onPick(a.prompt, a.scope)}
            className="group rounded-full border border-ink-100 bg-white px-2.5 py-1 text-xs font-medium text-ink-700 hover:border-brand-500 hover:bg-brand-50 hover:text-brand-700 disabled:opacity-50"
            title={a.hint || a.label}
          >
            {a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
